// Embedded Appsnube Billing — feature flag + iframe origin.
//
// Billing is a SEPARATE app (appsnube-billing) embedded as an iframe.
//
//   VITE_BILLING_ENABLED   — build-time PRE-BOOTSTRAP DEFAULT only. The
//                            AUTHORITATIVE source of truth for showing/hiding
//                            every billing surface is the BACKEND's
//                            `billing_enabled` (= billing_configured()), sent on
//                            the bootstrap and synced into the session store
//                            (`billingEnabled`). So an unconfigured backend hides
//                            all billing UI regardless of this flag; the flag only
//                            seeds the value for the brief window before bootstrap
//                            resolves (avoids a flash in prod where both agree).
//                            DEFAULTS to FALSE when unset.
//   VITE_BILLING_IFRAME_URL — origin of the running billing frontend. Local dev
//                            is http://localhost:5183; prod is the deployed URL.
//
// The embed is purely client-side: the billing iframe authenticates itself
// (its own session), so agentes-nube only has to render the frame.

export const BILLING_ENABLED =
  (import.meta.env.VITE_BILLING_ENABLED as string | undefined) === "true";

// @deprecated (centralized billing handshake, 2026-06-16). The iframe URL now
// comes from the backend `GET /billing/embed-token` response (`iframe_url`), so
// BillingPage no longer reads this env var. Kept only for backwards-compat with
// any tooling that still references it; safe to remove once nothing imports it.
export const BILLING_IFRAME_URL = (
  (import.meta.env.VITE_BILLING_IFRAME_URL as string | undefined) ??
  "http://localhost:5183"
).replace(/\/$/, "");
